// extracted by mini-css-extract-plugin
module.exports = {"txt":"Hero_txt__29BzB","muxPlayerSettings":"Hero_muxPlayerSettings__si3ck"};